import axios from "axios";
import { translateBackendMessage } from "@/lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Lotto 3 #6 "Ricordami": token may live in localStorage (remember=true)
  // or sessionStorage (remember=false). Read the first one found.
  let token = null;
  try { token = localStorage.getItem("tc_token"); } catch {}
  if (!token) { try { token = sessionStorage.getItem("tc_token"); } catch {} }
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Tell the backend which UI language to reply in (used by any backend-side i18n).
  try {
    const lang = localStorage.getItem("tc_lang") || "it";
    const localeMap = { it: "it-IT", en: "en-GB", fr: "fr-FR", de: "de-DE", es: "es-ES", pt: "pt-PT" };
    config.headers = config.headers || {};
    config.headers["Accept-Language"] = `${localeMap[lang] || "en-GB"},${lang};q=0.9,en;q=0.8`;
  } catch { /* localStorage unavailable */ }
  return config;
});

export default api;

// Response interceptor: translate backend Italian messages to the current UI
// language BEFORE they surface to callers (toast/error handlers). Falls back
// silently to the original string when no mapping is known.
api.interceptors.response.use(
  (response) => {
    try {
      const d = response?.data;
      if (d && typeof d === "object") {
        if (typeof d.detail === "string") d.detail = translateBackendMessage(d.detail);
        if (typeof d.message === "string") d.message = translateBackendMessage(d.message);
      }
    } catch { /* ignore */ }
    return response;
  },
  (error) => {
    try {
      const d = error?.response?.data;
      if (d && typeof d === "object") {
        if (typeof d.detail === "string") d.detail = translateBackendMessage(d.detail);
        if (typeof d.message === "string") d.message = translateBackendMessage(d.message);
      }
    } catch { /* ignore */ }
    return Promise.reject(error);
  }
);
